import { track } from '@vercel/analytics/react';

export function sendToVercelAnalytics({ id, name, value }) {
  track('Web Vitals', { 
    metricName: name, // e.g., 'CLS', 'FCP', 'LCP'
    metricId: id,     // The unique ID for the metric instance.
    metricValue: value, // The value of the metric.
    label: id,        // Use the metric ID as the label (or customize).
    category: 'Web Vitals', 
    nonInteraction: true, // Mark as non-interaction event.
  });
} 